import React from "react";
import "../Assets/css/ServicesSection.css";
// Importing images from src/Assets/icon/
import automation from "../Assets/icon/automation blue.png";
import robotic from "../Assets/icon/robot blue.png";
import machining from "../Assets/icon/P_mW.png";
import sheetMetal from "../Assets/icon/S_mc.png";
import design from "../Assets/icon/design blue.png";
import programming from "../Assets/icon/programing blue.png";
import printing from "../Assets/icon/printing blue.png";
import scanning from "../Assets/icon/scan blue.png";
import videoSrc from "../Assets/videos/vd2.mp4"; // Video import

const servicesLeft = [
  { name: "Automation", img: automation, link: "About" },
  { name: "ROBOTIC SOLUTIONS", img: robotic, link: "" },
  { name: "PRECISE MACHINING WORKS", img: machining, link: "" },
  { name: "SHEET METAL CONVERSION", img: sheetMetal, link: "" },
];

const servicesRight = [
  { name: "DESIGN & CONSULTATION", img: design, link: "" },
  { name: "PROGRAMMING", img: programming, link: "" },
  { name: "3D PRINTING", img: printing, link: "" },
  { name: "3D SCANNING", img: scanning, link: "" },
];

const ServicesSection = () => {
  return (
    <section className="header-wrap">
      <h5 class="elementor-heading-title elementor-size-default" style={{ color: "white" }}
      >OUR EXPERTISE</h5>

      <div className="wrap">
        {/* Left Sidebar */}
        <div id="sidebar-left">
          {servicesLeft.map((service, index) => (
            <div className="image-container" key={index}>
              <div style={{ paddingBottom: "10%" }}></div>
              <img src={service.img} style={{ height: "85px" }} alt={service.name} />
              <a style={{ color: "white", textDecoration: "none" }} href={service.link} rel="noopener noreferrer">
                <h6>{service.name}</h6>
              </a>
            </div>
          ))}
        </div>

        {/* Video in Center */}
        <div className="nomob" id="main-content">
          <div className="video-container">
            <video src={videoSrc} muted autoPlay loop playsInline></video>
          </div>
        </div>

        {/* Right Sidebar */}
        <div id="sidebar-right">
          {servicesRight.map((service, index) => (
            <div className="image-container" key={index}>
              <div style={{ paddingBottom: "10%" }}></div>
              <img src={service.img} style={{ height: "85px" }} alt={service.name} />
              <a style={{ color: "white", textDecoration: "none" }} href={service.link} rel="noopener noreferrer">
                <h6>{service.name}</h6>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
